import React from "react";

export const CommonSelectInput = ({
    name,
    options,
    value,
    onChange,
    onBlur,
    touched,
    errors,
    className = "form-select",
    placeholder = "Select an option",
}) => {
    return (
        <>
            <select
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                className={`w-full ${className} ${touched && errors ? "is-invalid" : ""}`}
                // className={`${className} ${touched && errors ? "is-invalid" : ""}`}
            >
                <option value="" disabled>
                    {placeholder}
                </option>
                {options.map((option, index) => (
                    <option key={index} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
            {touched && errors && (
                <div className="invalid-feedback">{errors}</div>
            )}
        </>
    );
};


